export const PoppingScroll = (instance) => {
	const scrollView = instance.scrollView 
	const isHTML = scrollView === document.documentElement
	const scrollElement = isHTML ? window : scrollView
	const scroll = () => {
		instance.updatePosition(); 
	};

	const clean = setTimeout(
		() => scrollElement.addEventListener('scroll', scroll, false),
		0
	);
	return {
		destroy() {
			clearTimeout(clean);
			scrollElement.removeEventListener('scroll', scroll, false);
		},
	};
};
